import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 1023px) {
    flex-direction: column;
  }
`

export const Row = styled.div`
  display: flex;
`

export const UndelinedNumber = styled.div`
  color: #666666;
  border-bottom: 2px solid #6202EE;
  margin: 0 5px 30px 8px;
  padding-top: 4px;
	
`

export const Form = styled.div`
  max-width: 620px;
  width: 100%;
  
  @media (min-width: 1024px) and (max-width: 1199px) {
    padding-right: 20px;
  }
`

export const Text = styled.span`
  display: block;
  margin-bottom: 30px;
  color: #202020;
  letter-spacing: 0.15px;
	padding-top: 4px;
`

export const Footer = styled.div``

export const Hr = styled.hr`
  height: 1px;
  margin-top: 10px;
  margin-bottom: 30px;
  border: none;
  background: rgba(0, 0, 0, 0.12);
`
